import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { SvgIcon } from "./../../SvgIcon";
import { test } from "utils/helpers";
import { toggleSettingPopup } from "store/actions/app";

const TabHeader = ({ title }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <div className="header-wrapper">
      <div className="setting-header setting-col">
        <div tabIndex="-1" className="settings-tab-content-header">
          {title}
        </div>
      </div>
      <div className="settings-close setting-col">
        <button
          aria-label={t("CLOSE_SETTINGS")}
          onClick={() => {
            dispatch(toggleSettingPopup());
          }}
          {...test("SETTINGS_CLOSE_BUTTON")}
        >
          <SvgIcon name="close-icon" customClass={"close-icon"} />
        </button>
      </div>
    </div>
  );
};
export default TabHeader;
